<br>
<form id="equipmentForm" #equipmentForm="ngForm">
  <h4>Equipment Information</h4>
  <div class="row-container">
    <div style="flex-grow: 2">
      <h6>Number</h6>
      @if (equipment) {
      <input pInputText fluid name="number" [(ngModel)]="equipment.number" required />
      }
    </div>
    <div style="flex-grow: 4">
      <h6>Name</h6>
      @if (equipment) {
      <input pInputText fluid name="name" [(ngModel)]="equipment.name" required />
      }
    </div>
    <div style="flex-grow: 3">
      <h6>Type</h6>
      @if (equipment) {
      <ng-select class="custom" required [items]="equipmentTypeOptions" placeholder="Select a Type" [selectOnTab]="true"
        name="equipmentType" bindLabel="type" [(ngModel)]="equipment.equipmentType">
      </ng-select>
      }
    </div>
    <div style="flex-grow: 3">
      <h6>Status</h6>
      @if (equipment) {
      <input pInputText fluid name="status" [ngModel]="equipmentStatus" disabled />
      }
    </div>
  </div>
  <div class="row-container">
    <div class="multiselect" style="flex-grow: 6">
      <h6>Skill/Certification</h6>
      @if (equipment) {    
        <p-multiselect autofocusFilter placeholder="Choose" name="equipmentSkills2" [options]="equipmentSkillOptions" [(ngModel)]="equipment.equipmentSkills" optionLabel="skill.name" fluid  display="chip"/>
<!--           
      <p-multiselect autofocusFilter placeholder="Choose" [options]="equipmentSkillOptions" name="equipmentSkills" [(ngModel)]="equipment.equipmentSkills"
        optionLabel="skill.name" fluid>
        <ng-template let-value pTemplate="selectedItems">
          @for (val of value; track val) {
          <div class="ui-multiselected-item-token ui-corner-all">
            <span>{{val.skill.name}}</span>
          </div>
          }
          @if (!value || value.length === 0) {
          <span class="ui-multiselected-empty-token ui-corner-all">Choose</span>
          }
        </ng-template>
        <ng-template let-skillOption pTemplate="item">
          {{skillOption.value.skill.name}}
        </ng-template>
      </p-multiselect> -->
      }
    </div>
    <div style="flex-grow: 4">
      <h6>Add Additional Information</h6>
      <p-checkbox binary="true" name="additionalInfo" [(ngModel)]="additionalInfo">
      </p-checkbox>
    </div>
  </div>
  @if (additionalInfo) {
  <div class="row-container">
    <div style="flex-grow: 4">
      <h6>VIN</h6>
      <input pInputText fluid name="vIN" [(ngModel)]="equipment.vIN" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Year</h6>
      <input pInputText fluid name="year" [(ngModel)]="equipment.year" type="number" />
    </div>

    <div style="flex-grow: 4">
      <h6>Make</h6>
      <input pInputText fluid name="make" [(ngModel)]="equipment.make" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Model</h6>
      <input pInputText fluid name="model" [(ngModel)]="equipment.model" type="text" />
    </div>
  </div>
  <div class="row-container">
    <div style="flex-grow: 4">
      <h6>Motor/Engine</h6>
      <input pInputText fluid name="motor" [(ngModel)]="equipment.motor" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Boom</h6>
      <input pInputText fluid name="boom" [(ngModel)]="equipment.boom" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Serial #</h6>
      <input pInputText fluid name="serialNo" [(ngModel)]="equipment.serialNo" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Fuel</h6>
      <input pInputText fluid name="fuel" [(ngModel)]="equipment.fuel" type="text" />
    </div>
  </div>
  <div class="row-container">
    <div style="flex-grow: 4">
      <h6>Tires</h6>
      <input pInputText fluid name="tires" [(ngModel)]="equipment.tires" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Engine Oil</h6>
      <input pInputText fluid name="engineOil" [(ngModel)]="equipment.engineOil" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Oil Drain Plug</h6>
      <input pInputText fluid name="oilDrainPlug" [(ngModel)]="equipment.oilDrainPlug" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Engine Oil Filter</h6>
      <input pInputText fluid name="engineOilFilter" [(ngModel)]="equipment.engineOilFilter" type="text" />
    </div>
  </div>
  <div class="row-container">
    <div style="flex-grow: 4">
      <h6>Fuel First Filter</h6>
      <input pInputText fluid name="fuelFirstFilter" [(ngModel)]="equipment.fuelFirstFilter" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Fuel/Water Sep</h6>
      <input pInputText fluid name="fuelWaterSep" [(ngModel)]="equipment.fuelWaterSep" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Air Filter</h6>
      <input pInputText fluid name="airFilter" [(ngModel)]="equipment.airFilter" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Hydraulic Oil</h6>
      <input pInputText fluid name="hydraulicOil" [(ngModel)]="equipment.hydraulicOil" type="text" />
    </div>
  </div>
  <div class="row-container">
    <div style="flex-grow: 4">
      <h6>Hydraulic Oil Filter</h6>
      <input pInputText fluid name="hydraulicOilFilter" [(ngModel)]="equipment.hydraulicOilFilter" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Grease</h6>
      <input pInputText fluid name="grease" [(ngModel)]="equipment.grease" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Coolant</h6>
      <input pInputText fluid name="coolant" [(ngModel)]="equipment.coolant" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Axel Filter</h6>
      <input pInputText fluid name="axelFilter" [(ngModel)]="equipment.axelFilter" type="text" />
    </div>
  </div>
  <div class="row-container">
    <div style="flex-grow: 4">
      <h6>Brakes</h6>
      <input pInputText fluid name="brakes" [(ngModel)]="equipment.brakes" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Power Steering Oil</h6>
      <input pInputText fluid name="powerSteeringOil" [(ngModel)]="equipment.powerSteeringOil" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Transmission Type</h6>
      <input pInputText fluid name="transmissionType" [(ngModel)]="equipment.transmissionType" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Transmission Oil</h6>
      <input pInputText fluid name="transmissionOil" [(ngModel)]="equipment.transmissionOil" type="text" />
    </div>
  </div>
  <div class="row-container">
    <div style="flex-grow: 4">
      <h6>Transmission Filter</h6>
      <input pInputText fluid name="transmissionFilter" [(ngModel)]="equipment.transmissionFilter" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Differential Type</h6>
      <input pInputText fluid name="differentialType" [(ngModel)]="equipment.differentialType" type="text" />
    </div>

    <div style="flex-grow: 4">
      <h6>Differential Oil</h6>
      <input pInputText fluid name="differentialOil" [(ngModel)]="equipment.differentialOil" type="text" />
    </div>
  </div>
  }
  <div class="row-container">
    <div style="flex-grow: 12;">
      <h6>Equipment Service Records</h6>
      <p-button type="button" class="addNewButton" (click)="addNewServiceRecord();">Add Service
        Record</p-button>
      @if (equipment) {
      <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols"
        [value]="equipment.equipmentServiceRecords" class="innerMaintenanceTable">
        <ng-template pTemplate="header" let-columns>
          <tr>
            @for (col of columns; track col) {
            <th [style.width]="col.width" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <td pEditableColumn><span class="p-column-title">{{columns[0].header}}</span>
              <input pInputText fluid [name]="'description'+rowIndex" [(ngModel)]="rowData.description"
                style="width:100%;" />
            </td>
            <td pEditableColumn><span class="p-column-title">{{columns[1].header}}</span>
              <p-datepicker [(ngModel)]="rowData.dateServicePerformed" [name]="'dateServicePerformed'+rowIndex"
                [appendTo]="'body'" class="dateInTable" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY">
              </p-datepicker>
            </td>
            <td pEditableColumn><span class="p-column-title">{{columns[2].header}}</span>
              <input pInputText fluid type="number" [name]="'mileage'+rowIndex" [(ngModel)]="rowData.mileage"
                style="width:100%;" />
            </td>
            <td pEditableColumn><span class="p-column-title">{{columns[3].header}}</span>
              <p-datepicker [(ngModel)]="rowData.inactiveDateFrom" [name]="'inactiveDateFrom'+rowIndex"
                (ngModelChange)="onESRFromDateChange(equipmentForm, rowIndex)" [appendTo]="'body'" class="dateInTable"
                dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" required>
              </p-datepicker>
            </td>
            <td pEditableColumn><span class="p-column-title">{{columns[4].header}}</span>
              <p-datepicker [(ngModel)]="rowData.inactiveDateTo" [minDate]="rowData.inactiveDateFrom"
                [appDateGreaterThanValidator]="rowData.inactiveDateFrom" (ngModelChange)="setEquipmentStatus()"
                [name]="'inactiveDateTo'+rowIndex" [appendTo]="'body'" class="dateInTable" dateFormat="mm/dd/yy"
                placeholder="MM/DD/YYYY">
              </p-datepicker>
            </td>
            <td><span class="p-column-title">{{columns[5].header}}</span>
              <p-button type="button" severity="danger"
                (click)="removeServiceRecord(rowIndex);">
                <i class="pi pi-trash"></i>
              </p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
      }
    </div>

  </div>
  <div class="row-container" style="flex-direction: row-reverse;">
    <p-button type="button" severity="success" (click)="save(equipmentForm)" [disabled]="saving" label="Save">
    </p-button>
    <p-button type="button" severity="warn" (click)="cancel()" label="Cancel">
    </p-button>
    <p-button type="button" (click)="delete()" severity="danger" [disabled]="disableDelete" label="Delete">
    </p-button>
  </div>
</form>